// extracted by mini-css-extract-plugin
export default {"beaconContainer":"Beacon__beaconContainer___auK4G","beaconDot":"Beacon__beaconDot___vbaRS","beaconIcon":"Beacon__beaconIcon___FVmhp","pulse":"Beacon__pulse___y6KWD"};